/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-06 10:07:33
 */
import accountflow from './accountflow/model';
import banktransaction from './banktransaction/model';
import paymanage from './paymanage/model';
import taxdeclaration from './taxdeclaration/model';
import accountstatement from './accountstatement/model';
import collectionmanage from './collectionmanage/model';
import platformsubsidy from './platformsubsidy/model';
import enterpriserecharge from './enterpriserecharge/model';
import provisionaltaxregister from './provisionaltaxregister/model';
import enterprisereconciliation from './enterprisereconciliation/model';
import microbusinessesstatements from './microbusinessesstatements/model';

export default [
    ...Object.values(accountflow.sagas),
    ...Object.values(banktransaction.sagas),
    ...Object.values(paymanage.sagas),
    ...Object.values(taxdeclaration.sagas),
    ...Object.values(accountstatement.sagas),
    ...Object.values(collectionmanage.sagas),
    ...Object.values(platformsubsidy.sagas),
    ...Object.values(enterpriserecharge.sagas),
    ...Object.values(provisionaltaxregister.sagas),
    ...Object.values(enterprisereconciliation.sagas),
    ...Object.values(microbusinessesstatements.sagas),
];